import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useMemo } from 'react';
import { defaultLoadingFallback } from './fallbacks';
export const Await = ({ promises, fallback = defaultLoadingFallback, children, }) => {
    const Lazy = useMemo(() => lazy(async () => {
        await Promise.all(promises);
        return {
            default: ({ children }) => children,
        };
    }), [promises]);
    return (_jsx(Suspense, { fallback: fallback, children: _jsx(Lazy, { children: children }) }));
};
//# sourceMappingURL=await.js.map